"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toJSON;

var _init = _interopRequireDefault(require("../_core/init"));

var _forown = _interopRequireDefault(require("../_helpers/forown"));

// converts Seemple.Object instance to ordinary object
function toJSON() {
  var _this = this;

  var recursive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var _initSeemple = (0, _init["default"])(this),
      keys = _initSeemple.keys;

  var result = {};
  (0, _forown["default"])(keys, function (_, key) {
    var value = _this[key]; // when recursive is true and when value has toJSON method then call it recusively

    if (recursive && value && typeof value.toJSON === 'function') {
      result[key] = value.toJSON(true);
    } else {
      result[key] = value;
    }
  });
  return result;
}
//# sourceMappingURL=tojson.js.map